module.exports = __webpack_public_path__ + "img/product-cate.356cd4d8.svg";